// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2_gQG","vLegacy":"SelectSecondary_vLegacy__Dvj2S","error":"SelectSecondary_error__3Li6W","disabled":"SelectSecondary_disabled__1ppDM"};